
const ContextProvider = ({ children }: { children: React.ReactNode; }) => {
  return (
    <>
      {children}
    </>
  );
};

export default ContextProvider;
